import { Component, OnInit } from '@angular/core';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {

  titleHaupttitel = ConstantsTexte.ANWENDUNGSNAME;
  titleNebentitel =  ConstantsTexte.ENTWICKLUNGSTEXT;

  constructor() {}

  ngOnInit(): void {}
}
